import { useState } from 'react';
import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { saveToLocalStorage } from '@utils/storage';

const ENDPOINT_URL = '/settings/get-settings';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetAllSettingsSuccessResponse = paths[url]['get']['responses']['200']['content']['application/json'];

export const useGetAllSettings = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const { setAllSettings } = useData();
    const [loading, setLoading] = useState<boolean>(false);

    const request = async () => {
        setLoading(true);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetAllSettingsSuccessResponse = await response.json();
            setAllSettings(data);
            saveToLocalStorage( 'allSettings', JSON.stringify(data), 120000);

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setLoading(false);
        }
    };

    return { request, loading };
};
